import type { ReactNode } from 'react'

import { Search, X } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Input } from '@/components/ui/input'

interface SearchInputProps {
    value: string
    onChange: (value: string) => void
    placeholder?: string
    className?: string
    ariaLabel?: string
}

const SearchInput = ({ value, onChange, placeholder = 'Search', className, ariaLabel }: SearchInputProps): ReactNode => {
    return (
        <div className={cn('relative w-full', className)}>
            <Search className='pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground' aria-hidden='true' />

            <Input
                type='search'
                value={value}
                onChange={event => onChange(event.target.value)}
                placeholder={placeholder}
                aria-label={ariaLabel ?? placeholder}
                className='pr-9 pl-9 [&::-webkit-search-cancel-button]:hidden'
            />

            {value && (
                <button
                    type='button'
                    onClick={() => onChange('')}
                    className='absolute top-1/2 right-2 flex size-6 -translate-y-1/2 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none'
                    aria-label='Clear search'
                >
                    <X className='size-4' />
                </button>
            )}
        </div>
    )
}

export default SearchInput
